import { render, staticRenderFns } from "./InfoMediaAvailable.vue?vue&type=template&id=39d1affe&scoped=true"
import script from "./InfoMediaAvailable.vue?vue&type=script&lang=js"
export * from "./InfoMediaAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1affe",
  null
  
)

export default component.exports